var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mainHeading withButton"
  }, [_vm._v(" Awaiting approval "), _c('button', {
    staticClass: "dialer-button dialer-button-primary mr-0",
    on: {
      "click": function ($event) {
        return _vm.$modal.show('AwaitApprovalModal');
      }
    }
  }, [_vm._v(" Genrate ")])]), _c('div', {
    staticClass: "mainDescription mb-4"
  }, [_vm._v(" Time off requests in certain stages which are waiting to be approved. ")]), _c('div', {
    staticClass: "hrmTabsContainer pt-3"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('div', {
      key: tab.id,
      class: `hrmTabsButton ${_vm.selectedTab.id == tab.id ? 'active' : ''} mr-16px`,
      on: {
        "click": function ($event) {
          _vm.selected_tab = tab;
        }
      }
    }, [_vm._v(_vm._s(tab.text))]);
  }), 0), _c('div', {
    staticClass: "mt-32px"
  }, [_vm.selectedTab.value == 'approval' ? [_c('div', {
    staticClass: "mainDescription mb-0"
  }, [_vm._v(" Time off requests in certain stages which are waiting to be approved. ")]), _c('div', {
    staticClass: "AwaitingApproval mt-32px"
  }, [_vm._m(0), _c('vb-table', {
    staticClass: "HrmTable",
    attrs: {
      "isListEmpty": _vm.isEmpty(_vm.filterAwaitingApprovals),
      "listLength": _vm.filterAwaitingApprovals.length,
      "loading": _vm.api.await_approval.send
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref) {
        var start = _ref.start,
          end = _ref.end;
        return _vm._l(_vm.filterAwaitingApprovals, function (data, index) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: index >= start && index <= end,
              expression: "index >= start && index <= end"
            }],
            key: data.user,
            staticClass: "dialer-row-select"
          }, [_c('td', {
            staticClass: "dialer-row-title one"
          }, [_c('div', {
            staticClass: "nameWithImage"
          }, [_c('div', {
            staticClass: "imageContainer"
          }, [_c('img', {
            attrs: {
              "src": require('@/assets/images/credit-card/1.jpeg')
            }
          })]), _c('div', {
            staticClass: "nameWithImage-text"
          }, [_vm._v(_vm._s(data.name))])])]), _c('td', {
            staticClass: "dialer-row-title two"
          }, [_c('div', {
            staticClass: "circleWithText"
          }, [_c('div', {
            staticClass: "circleContainer",
            staticStyle: {
              "background-color": "#D5761B"
            }
          }), _c('div', {
            staticClass: "circleWithText-text",
            staticStyle: {
              "color": "#D5761B"
            }
          }, [_vm._v(_vm._s(data.policy))])])]), _c('td', {
            staticClass: "dialer-row-title three"
          }, [_vm._v("05/09/2022 All day" + _vm._s(data.startDate))]), _c('td', {
            staticClass: "dialer-row-title four"
          }, [_vm._v("05/09/2022" + _vm._s(data.endDate))]), _c('td', {
            staticClass: "dialer-row-title five"
          }, [_c('b-dropdown', {
            staticClass: "ActionsDD",
            attrs: {
              "no-caret": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function () {
                return [_c('div', {
                  staticClass: "button-content"
                }, [_c('b-icon', {
                  staticClass: "downIcon",
                  attrs: {
                    "icon": "three-dots-vertical"
                  }
                })], 1)];
              },
              proxy: true
            }], null, true)
          }, [_c('b-dropdown-item', [_vm._v(" All teams" + _vm._s(data.actions) + " ")])], 1)], 1)]);
        });
      }
    }], null, false, 3058972558)
  })], 1)] : _vm._e(), _vm.selectedTab.value == 'resubmission' ? [_c('div', {
    staticClass: "mainDescription mb-0"
  }, [_vm._v(" Time off requests in certain stages which are waiting to be resubmission. ")]), _c('div', {
    staticClass: "AwaitingApproval mt-32px"
  }, [_vm._m(1), _c('vb-table', {
    staticClass: "HrmTable",
    attrs: {
      "isListEmpty": _vm.isEmpty(_vm.filterResubmissionApprovals),
      "listLength": _vm.filterResubmissionApprovals.length,
      "loading": _vm.api.resubmission_approval.send
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref2) {
        var start = _ref2.start,
          end = _ref2.end;
        return _vm._l(_vm.filterResubmissionApprovals, function (data, index) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: index >= start && index <= end,
              expression: "index >= start && index <= end"
            }],
            key: data.user,
            staticClass: "dialer-row-select"
          }, [_c('td', {
            staticClass: "dialer-row-title one"
          }, [_c('div', {
            staticClass: "nameWithImage"
          }, [_c('div', {
            staticClass: "imageContainer"
          }, [_c('img', {
            attrs: {
              "src": require('@/assets/images/credit-card/1.jpeg')
            }
          })]), _c('div', {
            staticClass: "nameWithImage-text"
          }, [_vm._v(_vm._s(data.name))])])]), _c('td', {
            staticClass: "dialer-row-title two"
          }, [_c('div', {
            staticClass: "circleWithText"
          }, [_c('div', {
            staticClass: "circleContainer",
            staticStyle: {
              "background-color": "#D5761B"
            }
          }), _c('div', {
            staticClass: "circleWithText-text",
            staticStyle: {
              "color": "#D5761B"
            }
          }, [_vm._v(_vm._s(data.policy))])])]), _c('td', {
            staticClass: "dialer-row-title three"
          }, [_vm._v(_vm._s(data.startDate))]), _c('td', {
            staticClass: "dialer-row-title four"
          }, [_vm._v(_vm._s(data.endDate))]), _c('td', {
            staticClass: "dialer-row-title five"
          }, [_c('b-dropdown', {
            staticClass: "ActionsDD",
            attrs: {
              "no-caret": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function () {
                return [_c('div', {
                  staticClass: "button-content"
                }, [_c('b-icon', {
                  staticClass: "downIcon",
                  attrs: {
                    "icon": "three-dots-vertical"
                  }
                })], 1)];
              },
              proxy: true
            }], null, true)
          }, [_c('b-dropdown-item', [_vm._v(" " + _vm._s(data.actions) + " ")])], 1)], 1)]);
        });
      }
    }], null, false, 1975991433)
  })], 1)] : _vm._e(), _vm.selectedTab.value == 'replacement' ? [_c('div', {
    staticClass: "mainDescription mb-0"
  }, [_vm._v(" Time off requests in certain stages which are waiting to be replacement. ")]), _c('div', {
    staticClass: "AwaitingApproval mt-32px"
  }, [_vm._m(2), _c('vb-table', {
    staticClass: "HrmTable",
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref3) {
        var start = _ref3.start,
          end = _ref3.end;
        return _vm._l(_vm.filterReplacementApprovals, function (data, index) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: index >= start && index <= end,
              expression: "index >= start && index <= end"
            }],
            key: data.user,
            staticClass: "dialer-row-select"
          }, [_c('td', {
            staticClass: "dialer-row-title one"
          }, [_c('div', {
            staticClass: "nameWithImage"
          }, [_c('div', {
            staticClass: "imageContainer"
          }, [_c('img', {
            attrs: {
              "src": require('@/assets/images/credit-card/1.jpeg')
            }
          })]), _c('div', {
            staticClass: "nameWithImage-text"
          }, [_vm._v(_vm._s(data.name))])])]), _c('td', {
            staticClass: "dialer-row-title two"
          }, [_c('div', {
            staticClass: "circleWithText"
          }, [_c('div', {
            staticClass: "circleContainer",
            staticStyle: {
              "background-color": "#D5761B"
            }
          }), _c('div', {
            staticClass: "circleWithText-text",
            staticStyle: {
              "color": "#D5761B"
            }
          }, [_vm._v(_vm._s(data.policy))])])]), _c('td', {
            staticClass: "dialer-row-title three"
          }, [_vm._v(_vm._s(data.startDate))]), _c('td', {
            staticClass: "dialer-row-title four"
          }, [_vm._v(_vm._s(data.endDate))]), _c('td', {
            staticClass: "dialer-row-title five"
          }, [_c('b-dropdown', {
            staticClass: "ActionsDD",
            attrs: {
              "no-caret": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function () {
                return [_c('div', {
                  staticClass: "button-content"
                }, [_c('b-icon', {
                  staticClass: "downIcon",
                  attrs: {
                    "icon": "three-dots-vertical"
                  }
                })], 1)];
              },
              proxy: true
            }], null, true)
          }, [_c('b-dropdown-item', [_vm._v(" " + _vm._s(data.actions) + " ")])], 1)], 1)]);
        });
      }
    }], null, false, 1112143240)
  })], 1)] : _vm._e()], 2), _c('AwaitApprovalModal')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "HrmTableHead-container"
  }, [_c('div', {
    staticClass: "HrmTableHead one"
  }, [_vm._v("Name")]), _c('div', {
    staticClass: "HrmTableHead two"
  }, [_vm._v("policy")]), _c('div', {
    staticClass: "HrmTableHead three"
  }, [_vm._v("Start date")]), _c('div', {
    staticClass: "HrmTableHead four"
  }, [_vm._v("end date")]), _c('div', {
    staticClass: "HrmTableHead five"
  }, [_vm._v("Actions")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "HrmTableHead-container"
  }, [_c('div', {
    staticClass: "HrmTableHead one"
  }, [_vm._v("Name")]), _c('div', {
    staticClass: "HrmTableHead two"
  }, [_vm._v("policy")]), _c('div', {
    staticClass: "HrmTableHead three"
  }, [_vm._v("Start date")]), _c('div', {
    staticClass: "HrmTableHead four"
  }, [_vm._v("end date")]), _c('div', {
    staticClass: "HrmTableHead five"
  }, [_vm._v("Actions")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "HrmTableHead-container"
  }, [_c('div', {
    staticClass: "HrmTableHead one"
  }, [_vm._v("Name")]), _c('div', {
    staticClass: "HrmTableHead two"
  }, [_vm._v("policy")]), _c('div', {
    staticClass: "HrmTableHead three"
  }, [_vm._v("Start date")]), _c('div', {
    staticClass: "HrmTableHead four"
  }, [_vm._v("end date")]), _c('div', {
    staticClass: "HrmTableHead five"
  }, [_vm._v("Actions")])]);

}]

export { render, staticRenderFns }